import { useEffect } from 'react';

import { Carousel, Button } from 'antd';

import { HeaderBox } from './home-header.styles';


const bgStyle = {
	width: '100%',
	height: '100%',
};


const HomeHeader = ({title, btnText, whatToDO, bgImage}) => {
	useEffect(() => {
		const setVh = () => {
		  // Get the viewport height and set it as a CSS variable
		  const vh = window.innerHeight * 0.01;
		  document.documentElement.style.setProperty('--vh', `${vh}px`);
		};
	
		// Set the initial value
		setVh();
	
		// Update the value when the window is resized
		window.addEventListener('resize', setVh);
	
		// Clean up the event listener on unmount
		return () => window.removeEventListener('resize', setVh);
	  }, []);

	const frameShii = [
		// {
		// 	img: viewA,
		// 	head: 'WORLD-CLASS DIGITAL BUSINESS DEVELOPMENT',
		// 	text: 'Begin your journey up the most successful online entrepreneurs list today',
		// 	// color: 'white'
		// },
		{
			img: bgImage,
			// head: 'Get your online store up and running with up to 20 high-value products - 100% FREE.',
			head: 'Empowering Your eCommerce Journey – From Launch to Growth, Tree Got You!',
			text: "From niche research for ecommerce to custom websites and app development, we've got you covered",
			btnText: 'Learn More'
			// color: 'red'
		},
		// {
		// 	img: viewC,
		// 	// head: 'BE SEEN!',
		// 	head: "FREE Website AUDIT: Discover why your store isn't selling and the simple fixes.",
		// 	text: "We bring your brand to limelight with effective marketing",
		// 	btnText: 'Get Free Offer'
		// 	// color: 'black'
		// 	// text: "What's the Use of a Beautiful Website or Apps if Prople Don't Know Abou it? Put Your Brand on the Limelight Today"
		// }
	];

	// about me
	// blogs
	// contacts
	// sign up/suscribe

	return(
		<Carousel 
			// arrows
			// infinite={false}
			autoplaySpeed={6500}
			speed={1350}
			autoplay
		>
			{
				frameShii.map((det) => <div style={bgStyle} key={det.head}>
						<div  style={{
							// height: '85vh',
							height: 'calc(var(--vh, 1vh) * 85)',
							backgroundImage: `url(${det.img}), url(${det.lowB})`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center top 40%',
							backgroundSize: 'cover',
							// color: `${det.color}`
						}}>
							<HeaderBox>
								<span className='headerInfoBox'>
									<h1>{title || det.head}</h1>
									{/* <p>{det.text}</p> */}
									<div style={{
										marginTop: '13px',
										// backgroundColor: 'yellow',
										display: 'flex',
										flexDirection: 'column',
										alignContent: 'center',
										justifyItems: 'center'
									}}>
										{/* <Link style={{
												// textDecoration: 'inherit',
												// backgroundColor: 'red',
												minWidth: 'max-content',
												alignSelf: 'center',
											}}
											to='../contactus'
											// onClick={toMail}
										> */}
											<Button 
												onClick={whatToDO}
												block={true}
												// size='large' 
												style={{
													fontFamily: 'Georgia, serif',
													fontSize: `${window.screen.width <= 1000 ? '1.1em' : '2em'}`,
													fontWeight: 'bold',
													// margin: '0.5em 0 0 0',
													padding: '0.5rem 1rem 0.5rem 1rem',
													width: '300px',
													minWidth: 'max-content',
													height: 'auto',
													alignSelf: 'center'
												}}
											>{btnText || det.btnText}</Button>
										{/* </Link> */}
										{/* <span style={{
												width: '100%',
												display: 'flex'
										}}> */}
											
										{/* </span> */}
										{/* <Button text='SEND' /> */}
									</div>
								</span>
							</HeaderBox>
						</div>
					</div>
					
				)
			}
			
		</Carousel>
	);
};

export default HomeHeader;